import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  // Track which dropdown is currently open (e.g., 'services', 'tech', etc.)
  const [openDropdown, setOpenDropdown] = useState(null);
  
  const location = useLocation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
    setOpenDropdown(null);
  };

  // Toggle individual dropdowns on click/tap
  const toggleDropdown = (e, menuName) => {
    e.preventDefault();
    setOpenDropdown(openDropdown === menuName ? null : menuName);
  };

  const getLinkClass = (path) => {
    return location.pathname === path 
      ? "nav-link active nav-pill" 
      : "nav-link text-light";
  };

  return (
    <nav 
      className="navbar navbar-expand-lg navbar-dark fixed-top bg-transparent custom-navbar px-4" 
      style={{ zIndex: 1000 }}
    >
      <div className="container-fluid">
        {/* Brand Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/" onClick={closeMenu}>
          <img
            src="img/logo.png"
            alt="Lidlbritain"
            width="240"
            className="d-inline-block align-text-top me-2"
          />
        </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleMenu}
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Collapsible Container */}
        <div 
          className={`collapse navbar-collapse justify-content-center ${isOpen ? 'show bg-dark p-3 rounded mt-2 shadow-lg' : ''}`} 
          id="navbarNav"
        >
          <ul className="navbar-nav gap-2">
            <li className="nav-item">
              <Link className={getLinkClass('/')} to="/" onClick={closeMenu}>Home</Link>
            </li>
            <li className="nav-item">
              <Link className={getLinkClass('/about-us')} to="/about-us" onClick={closeMenu}>About Us</Link>
            </li>

            {/* Services Dropdown */}
            <li className={`nav-item dropdown ${openDropdown === 'services' ? 'show' : ''}`}>
              <a
                className="nav-link dropdown-toggle text-light"
                href="#"
                role="button"
                onClick={(e) => toggleDropdown(e, 'services')}
                aria-expanded={openDropdown === 'services'}
              >
                Services
              </a>
              <ul className={`dropdown-menu shadow ${openDropdown === 'services' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/design-and-development" onClick={closeMenu}>Web Design and Development</Link></li>
                <li><Link className="dropdown-item" to="/mobile-app-development" onClick={closeMenu}>Mobile App Development</Link></li>
                <li><Link className="dropdown-item" to="/digital-marketing" onClick={closeMenu}>Digital Marketing</Link></li>
                <li><Link className="dropdown-item" to="/infrastructure-development" onClick={closeMenu}>Infrastructure Development</Link></li>
                <li><Link className="dropdown-item" to="/application-development" onClick={closeMenu}>Application Development</Link></li>
                <li><Link className="dropdown-item" to="/process-outsourcing" onClick={closeMenu}>Process Outsourcing</Link></li>
                <li><Link className="dropdown-item" to="/cloud-migration" onClick={closeMenu}>Cloud Migration</Link></li>
                <li><Link className="dropdown-item" to="/data-integration" onClick={closeMenu}>Data Integration</Link></li>
                <li><Link className="dropdown-item" to="/mainframe-computing" onClick={closeMenu}>Mainframe Computing</Link></li>
                <li><Link className="dropdown-item" to="/product-engineering" onClick={closeMenu}>Product Engineering</Link></li>
              </ul>
            </li>

            {/* Digital Transformation Dropdown */}
            <li className={`nav-item dropdown ${openDropdown === 'digital' ? 'show' : ''}`}>
              <a
                className="nav-link dropdown-toggle text-light"
                href="#"
                role="button"
                onClick={(e) => toggleDropdown(e, 'digital')}
                aria-expanded={openDropdown === 'digital'}
              >
                Digital Transformation
              </a>
              <ul className={`dropdown-menu shadow ${openDropdown === 'digital' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/customer-experience-cpq" onClick={closeMenu}>Customer Experience and CPQ</Link></li>
                <li><Link className="dropdown-item" to="/supply-chain-optimization" onClick={closeMenu}>Supply Chain Optimization</Link></li>
                <li><Link className="dropdown-item" to="/big-data-analytics" onClick={closeMenu}>Big Data and Analytics</Link></li>
                <li><Link className="dropdown-item" to="/mobility-and-ux" onClick={closeMenu}>Mobility and UX</Link></li>
                <li><Link className="dropdown-item" to="/ai-and-ml" onClick={closeMenu}>AI and ML</Link></li>
              </ul>
            </li>

            {/* Technology Dropdown */}
            <li className={`nav-item dropdown ${openDropdown === 'tech' ? 'show' : ''}`}>
              <a
                className="nav-link dropdown-toggle text-light"
                href="#"
                role="button"
                onClick={(e) => toggleDropdown(e, 'tech')}
                aria-expanded={openDropdown === 'tech'}
              >
                Technology
              </a>
              <ul className={`dropdown-menu shadow ${openDropdown === 'tech' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/sap-enterprise-systems" onClick={closeMenu}>SAP Enterprise Systems</Link></li>
                <li><Link className="dropdown-item" to="/salesforce-platforms" onClick={closeMenu}>Salesforce Platforms</Link></li>
                <li><Link className="dropdown-item" to="/microsoft-cloud-solutions" onClick={closeMenu}>Microsoft Cloud Solutions</Link></li>
                <li><Link className="dropdown-item" to="/aws-cloud-solutions" onClick={closeMenu}>AWS Cloud Solutions</Link></li>
              </ul>
            </li>

            {/* Industries Dropdown */}
            <li className={`nav-item dropdown ${openDropdown === 'industries' ? 'show' : ''}`}>
              <a
                className="nav-link dropdown-toggle text-light"
                href="#"
                role="button"
                onClick={(e) => toggleDropdown(e, 'industries')}
                aria-expanded={openDropdown === 'industries'}
              >
                Industries
              </a>
              <ul className={`dropdown-menu shadow ${openDropdown === 'industries' ? 'show' : ''}`}>
                <li><Link className="dropdown-item" to="/manufacturing-solutions" onClick={closeMenu}>Manufacturing Solutions</Link></li>
                <li><Link className="dropdown-item" to="/healthcare-biotech-solutions" onClick={closeMenu}>Healthcare and Biotech Solutions</Link></li>
                <li><Link className="dropdown-item" to="/automotive-solutions" onClick={closeMenu}>Automotive Solutions</Link></li>
                <li><Link className="dropdown-item" to="/media-and-entertainment" onClick={closeMenu}>Media and Entertainment</Link></li>
              </ul>
            </li>

            {/* Mobile Contact Button */}
            <li className="nav-item d-lg-none mt-2">
              <Link to="/contact" className="btn gradient-btn w-100 rounded-pill" onClick={closeMenu}>
                Contact Us &rarr;
              </Link>
            </li>
          </ul>
        </div>

        {/* Desktop CTA Button */}
        <div className="d-none d-lg-block">
          <Link to="/contact" className="btn gradient-btn px-4 py-2 rounded-pill">
            Contact Us &rarr;
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Header;